import React from 'react';
import EmbedBlock from './EmbedBlock';
import { EMBED_SIZE_MODES } from './embedLayout';
import EmbedLinkField from './EmbedLinkField';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';
import { puckPxWidthField } from '../../../puck/fields/puckPxWidthField';
import { puckMediaAspectRatioField } from '../../../media';
import { puckSectionField } from '../../../puck/fields/puckSectionField';
import { puckHorizontalAlignField } from '../../../puck/fields/puckHorizontalAlignField';
import { puckVerticalAlignField } from '../../../puck/fields/puckVerticalAlignField';

const embedFields = {
  _section1: puckSectionField('Lien'),
  /* Adresse : banque de liens, variable du CRM ou saisie libre. Le champ porte
     les trois et écrit les props des autres sources, cf. `EmbedLinkField`. */
  url: {
    type: 'custom',
    label: 'Adresse',
    render: ({ value, onChange }) => <EmbedLinkField value={value} onChange={onChange} />,
  },
  sizeMode: {
    type: 'radio',
    label: 'Taille',
    options: [
      { label: 'Celle du service', value: EMBED_SIZE_MODES.auto },
      { label: 'Ratio', value: EMBED_SIZE_MODES.ratio },
      { label: 'Hauteur fixe', value: EMBED_SIZE_MODES.height },
    ],
  },
  aspectRatio: {
    ...puckMediaAspectRatioField,
    label: 'Format',
    // « Auto (fichier) » n'a pas de sens ici : une intégration n'a pas de
    // dimensions propres à lire. Sans ratio choisi, on suit le service.
    options: puckMediaAspectRatioField.options.filter((o) => o.value !== 'auto'),
  },
  height: puckPxSpacingField('Hauteur', undefined, { max: 1600 }),
  _section2: puckSectionField('Affichage'),
  /* La prop garde son nom : elle porte du contenu en production. Seul le champ
     rejoint celui des autres blocs. */
  alignment: puckHorizontalAlignField('Alignement horizontal'),
  alignVertical: puckVerticalAlignField(),
  width: puckPxWidthField('Largeur'),
};

/** Seul le réglage de taille correspondant au mode choisi est affiché. */
function resolveEmbedFields(data, { fields }) {
  const next = {
    _section1: fields._section1, url: fields.url, sizeMode: fields.sizeMode,
  };
  if (data.props.sizeMode === EMBED_SIZE_MODES.ratio) next.aspectRatio = fields.aspectRatio;
  if (data.props.sizeMode === EMBED_SIZE_MODES.height) next.height = fields.height;
  next._section2 = fields._section2;
  next.alignment = fields.alignment;
  next.alignVertical = fields.alignVertical;
  next.width = fields.width;
  return next;
}

const embedBlockConfig = {
  label: 'Contenu externe',
  defaultProps: {
    url: '',
    sizeMode: EMBED_SIZE_MODES.auto,
    aspectRatio: '16/9',
    height: '',
    alignment: 'center',
    width: undefined,
    /* Lien de la banque dont `url` est la copie. Vide quand l'adresse a été
       saisie à la main — c'est le cas de tous les blocs déjà en base. */
    linkId: '',
    /* Variable du CRM dont `variableValue` est la copie — même triplet que la
       cible d'un bouton et que le nœud variable d'un texte.
       `source` n'a délibérément pas de défaut : Puck fusionne `defaultProps`
       SOUS les props stockées, un défaut masquerait donc la source des blocs
       déjà en base. `embedSourceKind` la déduit à la lecture. */
    variableKey: '',
    variableName: '',
    variableValue: '',
  },
  fields: embedFields,
  resolveFields: resolveEmbedFields,
  render: (props) => <EmbedBlock {...props} />,
};

export default embedBlockConfig;
